import React from 'react';
import { Link } from 'gatsby'

// import StarIcon from '../../assets/images/star-icon.png'
// import ServiceIcon1 from '../../assets/images/services/service-icon1.png'
// import ServiceIcon2 from '../../assets/images/services/service-icon2.png'
// import ServiceIcon3 from '../../assets/images/services/service-icon3.png'
// import ServiceIcon4 from '../../assets/images/services/service-icon4.png'
// import ServiceIcon5 from '../../assets/images/services/service-icon5.png'
// import ServiceIcon6 from '../../assets/images/services/service-icon6.png'

const Services = () => {
    return (
        <section id="services" className="services-area pt-100 pb-70 bg-f1f8fb">
            <div className="container">
                <div className="section-title">
                    <span className="sub-title">
                        <img src="https://firebasestorage.googleapis.com/v0/b/obacodersbrochurewebsite.appspot.com/o/star-icon.png?alt=media&token=792843ef-0407-4cb2-8f08-1f9e74156a72" alt="image" />
                        Our Services
                    </span>
                    <h2>Outsource Your Project Development</h2>
                    <p>You name it, we'll build it.</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-services-item-box">
                            <div className="icon">
                                <img src="https://firebasestorage.googleapis.com/v0/b/obacodersbrochurewebsite.appspot.com/o/service-icon1.png?alt=media&token=0e4b0c5f-e1a1-42c9-99bc-c4de8c1f013b" alt="Service Icon" />
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Project Management
                                </Link>
                            </h3>
                            <p>Rely on our teams collective experience to ensure you avoid costly technical debt.</p>

                            {/* <Link to="/service-details" className="read-more-btn">
                                Read More <i className="flaticon-right"></i>
                            </Link> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-services-item-box">
                            <div className="icon">
                                <img src="https://firebasestorage.googleapis.com/v0/b/obacodersbrochurewebsite.appspot.com/o/service-icon2.png?alt=media&token=63a3fd4d-6bec-4359-ba64-cc93e8c689f2" alt="Service Icon" />
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    AR & VR Development
                                </Link>
                            </h3>
                            <p>Immerse your users in completely new digital environments.</p>

                            {/* <Link to="/service-details" className="read-more-btn">
                                Read More <i className="flaticon-right"></i>
                            </Link> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-services-item-box">
                            <div className="icon">
                                <img src="https://firebasestorage.googleapis.com/v0/b/obacodersbrochurewebsite.appspot.com/o/service-icon3.png?alt=media&token=c9fa1253-a45a-4a71-a8a3-ff31039a28ee" alt="Service Icon" />
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Dev Outsourcing
                                </Link>
                            </h3>
                            <p>Turnkey custom software project solutions. You dream it we build it.</p>

                            {/* <Link to="/service-details" className="read-more-btn">
                                Read More <i className="flaticon-right"></i>
                            </Link> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-services-item-box">
                            <div className="icon">
                                <img src="https://firebasestorage.googleapis.com/v0/b/obacodersbrochurewebsite.appspot.com/o/service-icon4.png?alt=media&token=ab6401d2-bc30-4c92-b4de-4235598c127a" alt="Service Icon" />
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Software Testing & QA
                                </Link>
                            </h3>
                            <p>We'll manage the testing while you focus on feature development.</p>

                            {/* <Link to="/service-details" className="read-more-btn">
                                Read More <i className="flaticon-right"></i>
                            </Link> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-services-item-box">
                            <div className="icon">
                                <img src="https://firebasestorage.googleapis.com/v0/b/obacodersbrochurewebsite.appspot.com/o/service-icon5.png?alt=media&token=c2648255-26bc-4a13-83b1-ec9a4391a718" alt="Service Icon" />
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Mobile App Dev
                                </Link>
                            </h3>
                            <p>Whether native or hybrid, put it in a design doc and we'll put in an app.</p>

                            {/* <Link to="/service-details" className="read-more-btn">
                                Read More <i className="flaticon-right"></i>
                            </Link> */}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-services-item-box">
                            <div className="icon">
                                <img src="https://firebasestorage.googleapis.com/v0/b/obacodersbrochurewebsite.appspot.com/o/service-icon6.png?alt=media&token=553baa87-18b5-4589-af77-bd8b349be34f" alt="Service Icon" />
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Cloud Computing
                                </Link>
                            </h3>
                            <p>From AWS to Firebase &#38; everything in between, we have you covered.</p>

                            {/* <Link to="/service-details" className="read-more-btn">
                                Read More <i className="flaticon-right"></i>
                            </Link> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Services;